import { TranslationsContext } from '@teliaee/telia-translate';
import React, { useContext } from 'react';
import { Separator } from 'telia-front-react';
import { diilTranslateOrEmpty } from '../../util/TranslateUtil';
import MobileCallsInBaltic from './MobileCallsInBaltic';
import MobileRoaming from './MobileRoaming';
import { Item } from './types';

interface MobilePacketDataLimitsProps {
  item: Item;
}

const MobilePacketDataLimits: React.FC<MobilePacketDataLimitsProps> = (props) => {
  const { translate, translateOrEmpty } = useContext(TranslationsContext);
  const { item } = props;
  const { callsAndMessages, title } = item;
  const { value, label } = item.pricePerMonth;
  const tooltipTogglerText = diilTranslateOrEmpty(translateOrEmpty, 'packetItem.callsAndMessages');

  return (
    <>
      <h3 className="h4 text-bold text__margin-none">{title}</h3>
      <Separator spacing="xxsmall" color="invisible" />
      <MobileRoaming item={item} />
      {callsAndMessages && (
        <React.Fragment>
          <p>
            {tooltipTogglerText}
            <strong>{` ${callsAndMessages}`}</strong>
          </p>
        </React.Fragment>
      )}
      <MobileCallsInBaltic item={item} />
      <Separator spacing="medium" weight="thin" />
      <p className="h4">
        {translate('packetItem.pricePerMonth')}
        <span className="text-bold">{` ${value} ${label}`}</span>
      </p>
    </>
  );
};

export default MobilePacketDataLimits;
